import React from "react";
export default React.createContext(
  // {
  // item:[],
  // city: "",
  // current: [],
  // searchForCity: (city) => {},
// }
);
